

export default function toMM(measure) {
  switch (measure.ItemMeasureValueUnit) {
    case 'cm': return measure.ItemMeasureValue * 10;
    case 'mm': return measure.ItemMeasureValue;
    default: throw new Error(`Unsupported ItemMeasureValueUnit ${measure.ItemMeasureValueUnit}`);
  }
}
